// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".common-cls1___6d38169f11caa21efd7{/*!*/}.common-cls2__f9c0bd2c88d206042b7a{display:flex;align-items:center;position:relative;text-align:center;padding:20px 24px;background:#0c3b8d}@media(max-width: 991px){.common-cls2__f9c0bd2c88d206042b7a{flex-direction:column}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "common-cls1___6d38169f11caa21efd7",
	"cls2": "common-cls2__f9c0bd2c88d206042b7a common-cls1___6d38169f11caa21efd7"
};
export default ___CSS_LOADER_EXPORT___;
